import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useMediaQuery, Grid } from '@material-ui/core';
import LatestNewCard from './components/LatestNewsCard';
import Hero from './components/Hero';
import Pagination from '@material-ui/lab/Pagination';
import clsx from 'clsx';
import { NewsService } from 'services';
import { SectionWithArrows } from 'components/organisms';
import { useQueryParams, NumberParam, withDefault } from 'use-query-params';
import { useTranslation } from 'react-i18next';

const newsService = new NewsService();

const PAGE_SIZE = 5;

function paginate(array, pageSize, pageNumber) {
  return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize);
}

const useStyles = makeStyles(theme => ({
  root: {},
  pagination: {
    marginTop: theme.spacing(8),
    display: 'flex',
    justifyContent: 'center',
  },
  content: {
    height: '100%',
    minHeight: 420,
  },
}));

const LatestNews = props => {
  const { className, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });
  const [news, setNews] = useState([]);
  const [filters, setFilters] = useQueryParams({
    page: withDefault(NumberParam, 1),
  });

  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const { data } = await newsService.news(filters.page);

      setNews(data);
    })();
  }, [filters]);

  const handlePageChange = (event, value) => {
    setFilters(prev => ({ ...prev, page: value }));
  };

  return (
    <div className={clsx(className)}>
      <Hero />
      <SectionWithArrows className={classes.content}>
        <Grid container spacing={isMd ? 6 : 3}>
          {paginate(news, PAGE_SIZE, filters.page).map((item, index) => (
            <Grid item xs={12} key={index}>
              <LatestNewCard
                item={item}
                buttonText={t('COMMON.READ_MORE')}
                showMoreButton={true}
                showMoreButtonText={t('COMMON.SHOW_MORE')}
                showLessButtonText={t('COMMON.SHOW_LESS')}
              />
            </Grid>
          ))}
        </Grid>
        <div className={clsx(classes.pagination)}>
          <Pagination
            count={Math.ceil(news.length / PAGE_SIZE)}
            page={filters.page}
            onChange={handlePageChange}
            size="large"
          />
        </div>
      </SectionWithArrows>
    </div>
  );
};

LatestNews.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default LatestNews;
